import { SHOP_URL } from "../components/Header";

export default function AboutPage() {
  return (
    <main className="page">
      <h1>About this site</h1>
      <p>
        Salvagers is a competitive engine-building board game by Jake Kast, available{" "}
        <a href={SHOP_URL} target="_blank" rel="noreferrer">
          on TheGameCrafter
        </a>
        . This is the game's site, now hosted alongside the rest of the kast-dev family.
      </p>
      <p className="muted">
        Browsing needs no account. The small sign-in link in the footer is for the people who run the site.
      </p>
    </main>
  );
}
